const reportDesign = (context, { design }) => {
    document.dispatchEvent(
        new CustomEvent('ReportDesignRequested', {
            detail: {
                reportUrl: design.links.report,
                thumbnailUrl: design.previewUrl,
            },
        })
    );
};
export default reportDesign;



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/design-details/actions/report-design.js